// extracted by mini-css-extract-plugin
export default {"fullScreen":"HeroBanner_fullScreen__90Hjd"};